import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import style from '../../index.module.scss';
import ConfirmDialog from '@/components/confirmDialog/index';
import { DialogContent, DialogTitle } from '@mui/material';
import AccountRgiht from '@/assets/icons/deleteAccountRight.svg';
import AccountError from '@/assets/icons/deleteAccountError.svg';
import { deleteAccountApi } from '@/app/csr-src/apis/profile/accountSetting.api';
import { fetchGetOrderStatisInfo } from '@/app/csr-src/apis/profile/profile.api';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import UKDialog from '@/components/UKDialog';
import UKToast from '@/components/UKToast/index';
import UKLoadingIcon from '@/components/UKLoadingIcon';
import { useTranslation } from '@/i18n/client';
import JDILogin from '@/app/login/index.login';
import loginConfig from '@/intl-jdi-common-ssr/constants/loginConfig';
import cookieUtil from '@/intl-jdi-common-ssr/utils/cookieUtils';
import { isUserInfoOperationAllowed } from '@/app/login/utils/index';

const DeleteAccount = ({ open, closeFn, userInfo }: any) => {
  const { t } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [emailVerification, setEmailVerification] = useState(false);
  const [orderVerification, setOrderVerification] = useState(false);
  const [delTimes, setDelTimes] = useState(0);
  const [delCycle, setDelCycle] = useState(0);

  useEffect(() => {
    orderVerified();
  }, []);

  useEffect(() => {
    setDialogOpen(open);
  }, [open]);

  useEffect(() => {
    onUserInfoChange();
  }, [userInfo]);

  const orderVerified = async () => {
    const res: any = await fetchGetOrderStatisInfo();
    setIsLoading(false);
    if (res && res.code === '200') {
      setOrderVerification(
        res.data?.unpaidCount <= 0 && res.data?.waitRecCount <= 0 && res.data?.afterSaleCount <= 0,
      );
    } else {
      setOrderVerification(false);
    }
  };

  const onUserInfoChange = () => {
    if (userInfo) {
      const { email, limitConfig } = userInfo;
      if (!email) {
        setEmailVerification(true);
      } else if (userInfo.emailVerified == 0 && userInfo.email) {
        setEmailVerification(false);
      } else if (userInfo.emailVerified == 1 && userInfo.email) {
        setEmailVerification(true);
      }
      if (limitConfig) {
        const { delTimes, delCycle } = limitConfig;
        setDelTimes(delTimes);
        setDelCycle(delCycle);
      }
    }
  };

  const applyToDelete = () => {
    setConfirmDialogOpen(true);
  };

  const closeConfirmDialog = () => {
    setConfirmDialogOpen(false);
  };

  const closeDialog = () => {
    closeFn && closeFn();
    setDialogOpen(false);
  };

  const handleConfirmDelete = async () => {
    const [_, res]: any = await deleteAccountApi();
    if (res && res.data) {
      isUserInfoOperationAllowed() &&
        cookieUtil.deleteCookie(loginConfig.LOGIN.USER_SUCCESS_ACCOUNT);
      JDILogin.getInstance().jumpToLoginPage();
    } else {
      UKToast.show({
        content: res?.msg || t('common.message.deleteFailed'),
        icon: 'error',
      });
    }
    closeDialog();
    closeConfirmDialog();
  };

  const DialogStyle = {
    '& .MuiDialog-paper': {
      width: '520px',
      minHeight: '374px',
      borderRadius: '12px',
    },
    '& .MuiDialogTitle-root': {
      fontSize: '18px',
      fontWeight: 'bold',
      lineHeight: '24px',
    },
  };

  const ContentStyle = {
    paddingTop: '0',
  };

  const BtnStyle = {
    textTransform: 'none',
    width: '472px',
    height: '40px',
    fontSize: '16px',
    color: '#FFFFFF',
    background: '#CC0C1C',
    borderRadius: '4px',
    '&.Mui-disabled': {
      background: '#FF9FA7',
      color: '#FFFFFF',
    },
    '&:hover': {
      background: '#CC0C1C',
    },
  };

  return (
    <UKDialog open={dialogOpen} onClose={closeDialog} showCloseBtn={false} sx={DialogStyle}>
      <DialogTitle>{t('settings.deleteAccount')}</DialogTitle>
      <IconButton
        aria-label='close'
        onClick={closeDialog}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent className={style.deleteAccount} sx={ContentStyle}>
        {isLoading && <UKLoadingIcon />}
        {!isLoading && (
          <>
            <div className={style.deleteAccount_title}>
              {t('settings.deleteAccountInfo.applyToDeleteAccount')}
            </div>
            <div className={style.deleteAccount_conduct}>
              {t('settings.deleteAccountInfo.beforeDeletionJoybuyVerification')}
            </div>
            <div className={style.deleteAccount_note}>
              {t('settings.deleteAccountInfo.noteAccountDeleted')}
            </div>
            <div className={style.deleteAccount_frame}>
              <div className={style.deleteAccount_detectTitle}>
                {t('settings.deleteAccountInfo.idVerification')}
              </div>
              <div className={style.deleteAccount_deltectContent}>
                {emailVerification ? <AccountRgiht /> : <AccountError />}
                <span
                  className={
                    emailVerification
                      ? style.deleteAccount_contentRight
                      : style.deleteAccount_contentError
                  }
                >
                  {t('settings.deleteAccountInfo.ownershipAccountVerified')}
                </span>
              </div>
            </div>
            <div className={style.deleteAccount_frame}>
              <div className={style.deleteAccount_detectTitle}>
                {t('settings.deleteAccountInfo.accountOrderComplete')}
              </div>
              <div className={style.deleteAccount_deltectContent}>
                {orderVerification ? <AccountRgiht /> : <AccountError />}
                <span
                  className={
                    orderVerification
                      ? style.deleteAccount_contentRight
                      : style.deleteAccount_contentError
                  }
                >
                  {t('settings.deleteAccountInfo.noPendingOrdersAccount')}
                </span>
              </div>
            </div>
            <div className={style.deleteAccount_delete}>
              <Button
                sx={BtnStyle}
                onClick={applyToDelete}
                disableElevation
                disabled={!emailVerification || !orderVerification}
              >
                {t('settings.deleteAccountInfo.applyToDeleteAccount')}
              </Button>
            </div>
            <ConfirmDialog
              open={confirmDialogOpen}
              cancelButtonText={t('common.btnText.cancel')}
              customButtonText={t('common.btnText.delete')}
              handleClose={handleConfirmDelete}
              handleConfirm={closeConfirmDialog}
            >
              {/* 申请删除账户弹窗 */}
              <div>
                {t('settings.deleteAccountInfo.deleteAccountInformation', { delTimes, delCycle })}
              </div>
            </ConfirmDialog>
          </>
        )}
      </DialogContent>
    </UKDialog>
  );
};

export default DeleteAccount;
